/* ILY LOVEWEAR -- Product JS
   Size selector . Qty counter . Accordions . Lightbox */

(function () {
  'use strict';

  /* Size selector */
  document.querySelectorAll('.ily-product__size-btn:not(.is-unavailable)').forEach(btn => {
    btn.addEventListener('click', function () {
      const productId = this.dataset.productId;
      const container = document.getElementById('sizes-' + productId);
      container.querySelectorAll('.ily-product__size-btn').forEach(b => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
      const variantId = this.dataset.variantId;
      const variantPrice = this.dataset.variantPrice;
      const hiddenInput = document.getElementById('variant-id-' + productId);
      if (hiddenInput) hiddenInput.value = variantId;
      const priceEl = document.querySelector('.ily-product__price');
      if (priceEl && variantPrice) priceEl.textContent = variantPrice;
    });
  });

  /* Qty counter */
  document.querySelectorAll('.ily-product__qty').forEach(widget => {
    const valueEl = widget.querySelector('.ily-product__qty-value');
    const hiddenInput = widget.closest('form') && widget.closest('form').querySelector('input[name="quantity"]');
    let qty = 1;
    widget.querySelectorAll('.ily-product__qty-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        if (this.dataset.action === 'plus') qty = Math.min(qty + 1, 10);
        if (this.dataset.action === 'minus') qty = Math.max(qty - 1, 1);
        valueEl.textContent = qty;
        if (hiddenInput) hiddenInput.value = qty;
      });
    });
  });

  /* Accordions */
  document.querySelectorAll('.ily-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const item = this.closest('.ily-accordion__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.ily-accordion__item').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* Collection card hover */
  document.querySelectorAll('.ily-product-card').forEach(card => {
    const primary = card.querySelector('.ily-product-card__img-primary');
    const hover   = card.querySelector('.ily-product-card__img-hover');
    if (!primary || !hover) return;
    card.addEventListener('mouseenter', () => { primary.style.opacity = '0'; hover.style.opacity = '1'; });
    card.addEventListener('mouseleave', () => { primary.style.opacity = '1'; hover.style.opacity = '0'; });
  });

  /* Lightbox */
  const lightbox = document.getElementById('ily-lightbox');
  const lbImg    = document.getElementById('ily-lightbox-img');
  const lbClose  = document.getElementById('ily-lightbox-close');
  let zoomed     = false;

  if (lightbox && lbImg) {
    document.querySelectorAll('.ily-product__gallery-thumb').forEach(img => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () {
        lbImg.src = this.src.replace(/width=\d+/, 'width=2000');
        lbImg.alt = this.alt;
        lbImg.style.transform = 'scale(1)';
        zoomed = false;
        lightbox.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });

    lbImg.addEventListener('click', function () {
      zoomed = !zoomed;
      this.style.transform = zoomed ? 'scale(2)' : 'scale(1)';
      this.style.cursor = zoomed ? 'zoom-out' : ' zoom-in';
    });

    function closeLightbox() {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
      lbImg.style.transform = 'scale(1)';
      zoomed = false;
    }

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });
  }

})();
